import { SpaceProperties } from '../../../styles/definitions/size/typographyScale'

//TODO:  FIgure out what design wanted and make these types make sense
export type IconSizes =
	| {
			big?: undefined | false
			small: true
	  }
	| {
			big?: boolean
			small?: undefined | false
	  }

export const determineSize = ({ big, small }: IconSizes) => {
	const size = big ? SpaceProperties.Big : small ? SpaceProperties.Small : SpaceProperties.Base
	return { width: size, height: size }
}
